import { useRef, useMemo, useEffect, useCallback } from 'react';
import { IconNames } from '@shipengine/giger-theme';
import { useTranslation } from '@packlink/translation-provider';
import { Icon, IconSize, Button, ButtonSize, ButtonColor, ButtonVariant, Typography } from '@shipengine/giger';
import { getRowStyles, getRowInfoStyles, getRowInfoIconStyles, getRowAddressStyles, getRowAddressTitleStyles } from './RowStyles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

const Address = _ref => {
  let {
    address,
    businessName,
    id,
    expanded
  } = _ref;
  const {
    t
  } = useTranslation();
  return jsxs("label", {
    css: getRowAddressStyles,
    children: [jsx(Typography, {
      variant: "small",
      component: "strong",
      bold: true,
      css: getRowAddressTitleStyles(expanded),
      "aria-label": businessName,
      children: businessName
    }), jsx(Typography, {
      variant: "small",
      children: address.toLowerCase()
    }), jsx(Typography, {
      variant: "small",
      children: `${t('pudo.point.ref')}: ${id}`
    })]
  });
};
const Row = _ref2 => {
  let {
    dropOff,
    hover,
    active,
    selectedId,
    expanded,
    onConfirm,
    onActiveRow,
    onMouseEnter
  } = _ref2;
  const {
    t
  } = useTranslation();
  const itemRef = useRef(null);
  const rowHover = useMemo(() => [hover, active, selectedId].includes(dropOff.id), [hover, active, dropOff, selectedId]);
  useEffect(() => {
    if (dropOff.id === active && itemRef.current) {
      itemRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  }, [itemRef, active, dropOff]);
  const onRowClick = useCallback(() => onActiveRow(dropOff), [dropOff, onActiveRow]);
  const onRowHover = useCallback(() => onMouseEnter(dropOff.id), [dropOff, onMouseEnter]);
  const onKeyPress = e => e.key === 'Enter' && onActiveRow(dropOff);
  const confirmAddress = useCallback(() => onConfirm(dropOff), [dropOff, onConfirm]);
  const isActive = active === dropOff.id;
  return jsx("li", {
    ref: itemRef,
    role: "option",
    onClick: onRowClick,
    onKeyPress: onKeyPress,
    onMouseEnter: onRowHover,
    "aria-selected": isActive,
    "aria-label": dropOff.businessName,
    css: getRowStyles(expanded, rowHover, isActive),
    children: jsxs("div", {
      css: getRowInfoStyles,
      children: [jsx(Icon, {
        css: getRowInfoIconStyles(expanded),
        name: IconNames.MARKER,
        size: IconSize.SIZE_REGULAR
      }), jsx(Address, {
        ...dropOff,
        expanded: expanded
      }), jsx("div", {
        children: jsx(Button, {
          isFullWidth: true,
          isInactive: !rowHover,
          size: ButtonSize.SMALL,
          onClick: confirmAddress,
          color: ButtonColor.PRIMARY,
          variant: ButtonVariant.FILLED,
          "data-id": "pudo-list-row-confirm-button",
          children: t(dropOff.id === selectedId ? 'pudo.point.confirmed' : 'pudo.point.confirm')
        })
      })]
    })
  });
};
Row.displayName = 'PudoListRow';
var Row$1 = Row;

export { Address, Row$1 as default };
//# sourceMappingURL=Row.js.map
